import { useEffect, useMemo } from 'react';

import { useIsExternalUser } from '~/hooks/useIsExternalUser.ts';

import { updatePi } from './PulseInsights.utils.ts';

interface PulseInsightsProps {
  email: string;
  lang: string;
  token: string;
}

export function PulseInsights({
  email,
  lang,
  token,
}: PulseInsightsProps): null {
  const userId = useMemo(() => btoa(email), [email]);
  const userType = useIsExternalUser() ? 'external' : 'internal';

  useEffect(() => {
    if (!token) {
      return;
    }

    updatePi(
      {
        localizationCode: lang,
        userId,
        userType,
      },
      { token },
    );
  }, [lang, token, userId, userType]);

  return null;
}

PulseInsights.displayName = 'PulseInsights';
